import types from "./types";

const initialState = {
  fetchingAllModuleList: false,
  allModuleList: [],
  fetchingAllModuleListError: null,

  fetchingModuleCard: false,
  moduleCard: null,
  fetchingModuleCardError: null,

  fetchingModuleInformation: false,
  moduleInformation: {},
  fetchingModuleInformationError: null,

  fetchingUpdateModuleInformation: false,
  updatedModuleInformation: {},
  fetchingUpdateModuleInformationError: null,

  fetchingNewModuleInformation: false,
  newModuleInformation: {},
  fetchingNewModuleInformationError: null,

  fetchingDeletingModule: false,
  deletedModule: [],
  deleteModuleError: null,

  fetchingEducationForm: false,
  educationForm: {},
  fetchingEducationFormError: null,

  fetchingTrialForm: false,
  trialForm: {},
  fetchingTrialFormError: null,

  fetchingModulePurpose: false,
  modulePurpose: {},
  fetchingModulePurposeError: null,

  fetchingModuleResultSkill: false,
  moduleResultSkill: {},
  fetchingModuleResultSkillError: null,

  fetchingModuleDigitalUsage: false,
  digitalUsage: {},
  fetchingModuleDigitalUsageError: null,

  fetchingModuleAbility: false,
  moduleAbility: [],
  fetchingModuleAbilityError: null,

  fetchingNewModuleAbility: false,
  newModuleAbility: {},
  fetchingNewModuleAbilityError: null,

  fetchingUpdateModuleAbility: false,
  updateModuleAbility: {},
  fetchingUpdateAbilityError: null,

  fetchingDeleteModuleAbility: false,
  deleteModuleAbility: {},
  fetchingDeleteAbilityError: null,

  fetchingAddModuleCardLogo: false,
  addModuleCardLogo: {},
  fetchingAddModuleCardLogoError: null,

  fetchingDeleteModuleCardLogo: false,
  deleteModuleCardLogo: {},
  fetchingDeleteModuleCardLogoError: null,

  fetchingAddModuleProgram: false,
  fetchingAddModuleProgramError: null,

  fetchingDeleteModuleProgram: false,
  fetchingDeleteModuleProgramError: null,

  fetchingAllModuleVolume: false,
  allModuleVolume: [],
  fetchingAllModuleVolumeError: null,

  fetchingAddModuleVolume: false,
  moduleVolume: {},
  fetchingAddModuleVolumeError: null,

  fetchingUpdateModuleVolume: false,
  updateModuleVolume: {},
  fetchingUpdateModuleVolumeError: null,

  fetchingDeleteVolume: false,
  deleteModuleVolume: {},
  fetchingDeleteoduleVolumeError: null,

  fetchingAllModuleThemeVolume: false,
  allModuleThemeVolume: [],
  fetchingAllModuleThemeVolumeError: null,

  fetchingAllModuleAbilityTheme: false,
  allModuleAbilityTheme: [],
  fetchingAllModuleAbilityThemeError: null,

  fetchingAddModuleThemeVolume: false,
  moduleThemeVolume: {},
  fetchingAddModuleThemeVolumeError: null,

  fetchingUpdateModuleThemeVolume: false,
  updateModuleThemeVolume: {},
  fetchingUpdateModuleThemeVolumeError: null,

  fetchingDeleteModuleThemeVolume: false,
  deletedThemeVolume: {},
  fetchingDeleteModuleThemeVolumeError: null,

  fetchingAllModuleLesson: false,
  allModuleLesson: [],
  fetchingAllModuleLessonError: null,

  fetchingAllModuleLessonTheme: false,
  allModuleLessonTheme: [],
  fetchingAllModuleLessonThemeError: null,

  fetchingAddModuleLesson: false,
  moduleLesson: {},
  fetchingAddModuleLessonError: null,

  fetchingUpdateModuleLesson: false,
  updateModuleLesson: {},
  fetchingUpdateModuleLessonError: null,

  fetchingDeleteModuleLesson: false,
  deleteModuleLesson: {},
  fetchingDeleteModuleLessonError: null,

  fetchingAllLessonType: false,
  allLessonType: [],
  fetchingAllLessonTypeError: null,

  fetchingAllResourceList: false,
  allResourceList: [],
  fetchingAllResourceListError: null,

  fetchingLessonResourceList: false,
  lessonResourceList: [],
  fetchingLessonResourceListError: null,

  fetchingAllRoomTypesList: false,
  allRoomTypesList: [],
  fetchingAllRoomTypesListError: null,

  fetchingAllModuleRoomList: false,
  allModuleRoomList: [],
  fetchingAllModuleRoomListError: null,

  fetchingModuleRoomList: false,
  moduleRoomList: {},
  fetchingModuleRoomListError: null,

  fetchingUpdateModuleRoom: false,
  updatedModuleRoom: {},
  fetchingUpdateModuleRoomError: null,

  fetchingDeleteModuleRoom: false,
  deletedModuleRoom: {},
  fetchingDeleteModuleRoomError: null,

  fetchingAllModuleResourceList: false,
  allModuleResourceList: [],
  fetchingAllModuleResourceListError: null,

  fetchingAddModuleResource: false,
  moduleResource: {},
  fetchingAddModuleResourceError: null,

  fetchingUpdateModuleResource: false,
  updatedModuleResource: {},
  fetchingUpdateModuleResourceError: null,

  fetchingDeleteModuleResource: false,
  deletedModuleResource: {},
  fetchingDeleteModuleResourceError: null,

  fetchingAllResourceTypeList: false,
  allResourceTypeList: [],
  fetchingAllResourceTypeListError: null,

  fetchingAllModuleReferenceList: false,
  allModuleReferenceList: [],
  fetchingAllModuleReferenceListError: null,

  fetchingAddModuleReference: false,
  moduleReference: {},
  fetchingAddModuleReferenceError: null,

  fetchingUpdateModuleReference: false,
  updatedModuleReference: {},
  fetchingUpdateModuleReferenceError: null,

  fetchingDeleteModuleReference: false,
  deletedModuleReference: {},
  fetchingDeleteModuleReferenceError: null,

  fetchingAllModuleSiteList: false,
  allModuleSiteList: [],
  fetchingAllModuleSiteListError: null,

  fetchingAddModuleSite: false,
  moduleSite: {},
  fetchingAddModuleSiteError: null,

  fetchingUpdateModuleSite: false,
  updatedModuleSite: {},
  fetchingUpdateModuleSiteError: null,

  fetchingDeleteModuleSite: false,
  deletedModuleSite: {},
  fetchingDeleteModuleSiteError: null,

  fetchingModuleSchedule: false,
  moduleSchedule: {},
  fetchingModuleScheduleError: null,

  fetchingModuleEstimate: false,
  moduleEstimate: {},
  fetchingModuleEstimateError: null,

  fetchingAllModuleCriterionList: false,
  allModuleCriterionList: [],
  fetchingAllModuleCriterionListError: null,

  fetchingAddModuleCriterion: false,
  moduleCriterion: {},
  fetchingAddModuleCriterionError: null,

  fetchingUpdateModuleCriterion: false,
  updatedModuleCriterion: {},
  fetchingUpdateModuleCriterionError: null,

  fetchingDeleteModuleCriterion: false,
  deletedModuleCriterion: {},
  fetchingDeleteModuleCriterionError: null,

  fetchingAllModuleCompilers: false,
  allModuleCompilers: [],
  fetchingAllModuleCompilersError: null,

  fetchingModuleCompilers: false,
  moduleCompilers: {},
  fetchingModuleCompilersError: null,

  fetchingOrganizationStaff: false,
  organizationStaff: [],
  fetchingOrganizationStaffError: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_MODULES_LIST_REQUEST:
      return {
        ...state,
        fetchingAllModuleList: true,
        fetchingAllModuleListError: null
      };
    case types.GET_ALL_MODULES_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllModuleList: false,
        allModuleList: action.allModuleList,
        fetchingAllModuleListError: null
      };
    case types.GET_ALL_MODULES_LIST_ERROR:
      return {
        ...state,
        fetchingAllModuleList: false,
        fetchingAllModuleListError: action.fetchingAllModuleListError
      };

    case types.GET_MODULE_CARD_REQUEST:
      return {
        ...state,
        fetchingModuleCard: true,
        fetchingModuleCardError: null
      };
    case types.GET_MODULE_CARD_COMPLETED:
      return {
        ...state,
        fetchingModuleCard: false,
        moduleCard: action.moduleCard,
        fetchingModuleCardError: null
      };
    case types.GET_MODULE_CARD_ERROR:
      return {
        ...state,
        fetchingModuleCard: false,
        fetchingModuleCardError: action.fetchingModuleCardError
      };

    case types.GET_MODULE_INFORMATION_REQUEST:
      return {
        ...state,
        fetchingModuleInformation: true,
        fetchingModuleInformationError: null
      };
    case types.GET_MODULE_INFORMATION_COMPLETED:
      return {
        ...state,
        fetchingModuleInformation: false,
        moduleInformation: action.moduleInformation,
        fetchingModuleInformationError: null
      };
    case types.GET_MODULE_INFORMATION_ERROR:
      return {
        ...state,
        moduleInformation: null,
        fetchingModuleInformationError: action.fetchingModuleInformationError
      };

    case types.UPDATE_MODULE_INFORMATION_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleInformation: true,
        fetchingUpdateModuleInformationError: null
      };
    case types.UPDATE_MODULE_INFORMATION_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleInformation: false,
        updatedModuleInformation: action.updatedModuleInformation,
        fetchingUpdateModuleInformationError: null
      };
    case types.UPDATE_MODULE_INFORMATION_ERROR:
      return {
        ...state,
        fetchingUpdateModuleInformation: false,
        fetchingUpdateModuleInformationError:
          action.fetchingUpdateModuleInformationError
      };

    case types.ADD_NEW_MODULE_INFORMATION_REQUEST:
      return {
        ...state,
        fetchingNewModuleInformation: true,
        fetchingNewModuleInformationError: null
      };
    case types.ADD_NEW_MODULE_INFORMATION_COMPLETED:
      return {
        ...state,
        fetchingNewModuleInformation: false,
        newModuleInformation: action.newModuleInformation,
        fetchingNewModuleInformationError: null
      };
    case types.ADD_NEW_MODULE_INFORMATION_ERROR:
      return {
        ...state,
        fetchingNewModuleInformation: false,
        fetchingNewModuleInformationError:
          action.fetchingNewModuleInformationError
      };

    case types.DELETE_MODULE_REQUEST:
      return {
        ...state,
        fetchingDeletingModule: true,
        deleteModuleError: null
      };
    case types.DELETE_MODULE_COMPLETED:
      return {
        ...state,
        fetchingDeletingModule: false,
        deletedModule: action.deletedModule,
        deleteModuleError: null
      };
    case types.DELETE_MODULE_ERROR:
      return {
        ...state,
        fetchingDeletingModule: false,
        deleteModuleError: action.deleteModuleError
      };

    case types.CHANGE_MODULE_IFORMATION:
      return {
        ...state,
        moduleInformation: action.moduleInformation
      };

    case types.CHANGE_MODULE_PURPOSE:
      return {
        ...state,
        modulePurpose: action.modulePurpose
      };

    case types.CHANGE_MODULE_RESULT_SKILL:
      return {
        ...state,
        moduleResultSkill: action.moduleResultSkill
      };

    case types.CHANGE_MODULE_DIGITAL_USAGE:
      return {
        ...state,
        digitalUsage: action.digitalUsage
      };

    case types.CHANGE_MODULE_SCHEDULE:
      return {
        ...state,
        moduleSchedule: action.moduleSchedule
      };

    case types.CHANGE_MODULE_ESTIMATE:
      return {
        ...state,
        moduleEstimate: action.moduleEstimate
      };

    case types.GET_EDUCATION_FORM_REQUEST:
      return {
        ...state,
        fetchingEducationForm: true,
        fetchingEducationFormError: null
      };
    case types.GET_EDUCATION_FORM_COMPLETED:
      return {
        ...state,
        fetchingEducationForm: false,
        educationForm: action.educationForm,
        fetchingEducationFormError: null
      };
    case types.GET_EDUCATION_FORM_ERROR:
      return {
        ...state,
        fetchingEducationFormError: action.fetchingEducationFormError
      };

    case types.GET_TRIAL_FORM_REQUEST:
      return {
        ...state,
        fetchingTrialForm: true,
        fetchingTrialFormError: null
      };
    case types.GET_TRIAL_FORM_COMPLETED:
      return {
        ...state,
        fetchingTrialForm: false,
        trialForm: action.trialForm,
        fetchingTrialFormError: null
      };
    case types.GET_TRIAL_FORM_ERROR:
      return {
        ...state,
        fetchingTrialFormError: action.fetchingTrialFormError
      };

    case types.GET_MODULE_PURPOSE_REQUEST:
      return {
        ...state,
        fetchingModulePurpose: true
      };
    case types.GET_MODULE_PURPOSE_COMPLETED:
      return {
        ...state,
        fetchingModulePurpose: false,
        modulePurpose: action.modulePurpose
      };
    case types.GET_MODULE_PURPOSE_ERROR:
      return {
        ...state,
        fetchingModulePurposeError: action.modulePurposeRequestError
      };

    case types.GET_MODULE_RESULT_SKILL_REQUEST:
      return {
        ...state,
        fetchingModuleResultSkill: true
      };
    case types.GET_MODULE_RESULT_SKILL_COMPLETED:
      return {
        ...state,
        fetchingModuleResultSkill: false,
        moduleResultSkill: action.moduleResultSkill
      };
    case types.GET_MODULE_RESULT_SKILL_ERROR:
      return {
        ...state,
        fetchingModulePurposeError: action.fetchingModuleResultSkillError
      };

    case types.GET_MODULE_ABILITY_REQUEST:
      return {
        ...state,
        fetchingModuleAbility: true
      };
    case types.GET_MODULE_ABILITY_COMPLETED:
      return {
        ...state,
        fetchingModuleAbility: false,
        moduleAbility: action.moduleAbility
      };
    case types.GET_MODULE_ABILITY_ERROR:
      return {
        ...state,
        fetchingModuleAbility: false,
        fetchingModuleAbilityError: action.fetchingModuleAbilityError
      };

    case types.ADD_NEW_MODULE_ABILITY_REQUEST:
      return {
        ...state,
        fetchingNewModuleAbility: true
      };
    case types.ADD_NEW_MODULE_ABILITY_COMPLETED:
      return {
        ...state,
        fetchingNewModuleAbility: false,
        newModuleAbility: action.newModuleAbility
      };
    case types.ADD_NEW_MODULE_ABILITY_ERROR:
      return {
        ...state,
        fetchingNewModuleAbility: false,
        fetchingNewModuleAbilityError: action.fetchingNewModuleAbilityError
      };

    case types.UPDATE_MODULE_ABILITY_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleAbility: true
      };
    case types.UPDATE_MODULE_ABILITY_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleAbility: false,
        updateModuleAbility: action.updateModuleAbility
      };
    case types.UPDATE_MODULE_ABILITY_ERROR:
      return {
        ...state,
        fetchingUpdateModuleAbility: false,
        fetchingUpdateAbilityError: action.fetchingUpdateAbilityError
      };

    case types.DELETE_MODULE_ABILITY_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleAbility: true
      };
    case types.DELETE_MODULE_ABILITY_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleAbility: false,
        deleteModuleAbility: action.deleteModuleAbility
      };
    case types.DELETE_MODULE_ABILITY_ERROR:
      return {
        ...state,
        fetchingDeleteModuleAbility: false,
        fetchingDeleteAbilityError: action.fetchingDeleteAbilityError
      };

    case types.GET_MODULE_DIGITAL_USAGE_REQUEST:
      return {
        ...state,
        fetchingModuleDigitalUsage: true
      };
    case types.GET_MODULE_DIGITAL_USAGE_COMPLETED:
      return {
        ...state,
        fetchingModuleDigitalUsage: false,
        digitalUsage: action.digitalUsage
      };
    case types.GET_MODULE_DIGITAL_USAGE_ERROR:
      return {
        ...state,
        fetchingModuleDigitalUsage: false,
        fetchingModuleDigitalUsageError: action.fetchingModuleDigitalUsageError
      };

    case types.ADD_MODULE_CARD_LOGO_REQUEST:
      return {
        ...state,
        fetchingAddModuleCardLogo: true
      };
    case types.ADD_MODULE_CARD_LOGO_COMPLETED:
      return {
        ...state,
        fetchingAddModuleCardLogo: false,
        addModuleCardLogo: action.addModuleCardLogo
      };
    case types.ADD_MODULE_CARD_LOGO_ERROR:
      return {
        ...state,
        fetchingAddModuleCardLogo: false,
        fetchingAddModuleCardLogoError: action.fetchingAddModuleCardLogoError
      };

    case types.DELETE_MODULE_CARD_LOGO_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleCardLogo: true
      };
    case types.DELETE_MODULE_CARD_LOGO_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleCardLogo: false,
        deleteModuleCardLogo: action.deleteModuleCardLogo
      };
    case types.DELETE_MODULE_CARD_LOGO_ERROR:
      return {
        ...state,
        fetchingDeleteModuleCardLogo: false,
        fetchingDeleteModuleCardLogoError:
          action.fetchingDeleteModuleCardLogoError
      };

    case types.ADD_MODULE_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingAddModuleProgram: true
      };
    case types.ADD_MODULE_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingAddModuleProgram: false
      };
    case types.ADD_MODULE_PROGRAM_ERROR:
      return {
        ...state,
        fetchingAddModuleProgram: false,
        fetchingAddModuleProgramError: action.fetchingAddModuleProgramError
      };

    case types.DELETE_MODULE_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleProgram: true
      };
    case types.DELETE_MODULE_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleProgram: false
      };
    case types.DELETE_MODULE_PROGRAM_ERROR:
      return {
        ...state,
        fetchingDeleteModuleProgram: false,
        fetchingDeleteModuleProgramError:
          action.fetchingDeleteModuleProgramError
      };

    case types.GET_ALL_MODULE_VOLUME_REQUEST:
      return {
        ...state,
        fetchingAllModuleVolume: true
      };
    case types.GET_ALL_MODULE_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingAllModuleVolume: false,
        allModuleVolume: action.allModuleVolume
      };
    case types.GET_ALL_MODULE_VOLUME_ERROR:
      return {
        ...state,
        fetchingAllModuleVolume: false,
        fetchingAllModuleVolumeError: action.fetchingAllModuleVolumeError
      };

    case types.ADD_MODULE_VOLUME_REQUEST:
      return {
        ...state,
        fetchingAddModuleVolume: true
      };
    case types.ADD_MODULE_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingAddModuleVolume: false,
        moduleVolume: action.moduleVolume
      };
    case types.ADD_MODULE_VOLUME_ERROR:
      return {
        ...state,
        fetchingAddModuleVolume: false,
        fetchingAddModuleVolumeError: action.fetchingAddModuleVolumeError
      };

    case types.UPDATE_MODULE_VOLUME_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleVolume: true
      };
    case types.UPDATE_MODULE_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleVolume: false,
        updateModuleVolume: action.updateModuleVolume
      };
    case types.UPDATE_MODULE_VOLUME_ERROR:
      return {
        ...state,
        fetchingUpdateModuleVolume: false,
        fetchingUpdateModuleVolumeError: action.fetchingUpdateModuleVolumeError
      };

    case types.DELETE_MODULE_VOLUME_REQUEST:
      return {
        ...state,
        fetchingDeleteVolume: true
      };
    case types.DELETE_MODULE_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingDeleteVolume: false,
        deleteModuleVolume: action.deleteModuleVolume
      };
    case types.DELETE_MODULE_VOLUME_ERROR:
      return {
        ...state,
        fetchingDeleteVolume: false,
        fetchingDeleteoduleVolumeError: action.fetchingDeleteoduleVolumeError
      };

    case types.GET_ALL_MODULE_THEME_VOLUME_REQUEST:
      return {
        ...state,
        fetchingAllModuleThemeVolume: true
      };
    case types.GET_ALL_MODULE_THEME_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingAllModuleThemeVolume: false,
        allModuleThemeVolume: action.allModuleThemeVolume
      };
    case types.GET_ALL_MODULE_THEME_VOLUME_ERROR:
      return {
        ...state,
        fetchingAllModuleThemeVolume: false,
        fetchingAllModuleThemeVolumeError:
          action.fetchingAllModuleThemeVolumeError
      };

    case types.ADD_MODULE_THEME_VOLUME_REQUEST:
      return {
        ...state,
        fetchingAddModuleThemeVolume: true
      };
    case types.ADD_MODULE_THEME_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingAddModuleThemeVolume: false,
        moduleThemeVolume: action.moduleThemeVolume
      };
    case types.ADD_MODULE_THEME_VOLUME_ERROR:
      return {
        ...state,
        fetchingAddModuleThemeVolume: false,
        fetchingAddModuleThemeVolumeError:
          action.fetchingAddModuleThemeVolumeError
      };

    case types.DELETE_MODULE_THEME_VOLUME_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleThemeVolume: true
      };
    case types.DELETE_MODULE_THEME_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleThemeVolume: false,
        deletedThemeVolume: action.deletedThemeVolume
      };
    case types.DELETE_MODULE_THEME_VOLUME_ERROR:
      return {
        ...state,
        fetchingDeleteModuleThemeVolume: false,
        fetchingDeleteModuleThemeVolumeError:
          action.fetchingDeleteModuleThemeVolumeError
      };

    case types.UPDATE_MODULE_THEME_VOLUME_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleThemeVolume: true
      };
    case types.UPDATE_MODULE_THEME_VOLUME_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleThemeVolume: false,
        updateModuleThemeVolume: action.updateModuleThemeVolume
      };
    case types.UPDATE_MODULE_THEME_VOLUME_ERROR:
      return {
        ...state,
        fetchingUpdateModuleThemeVolume: false,
        fetchingUpdateModuleThemeVolumeError:
          action.fetchingUpdateModuleThemeVolumeError
      };

    case types.GET_ALL_MODULE_ABILITY_THEME_REQUEST:
      return {
        ...state,
        fetchingAllModuleAbilityTheme: true
      };
    case types.GET_ALL_MODULE_ABILITY_THEME_COMPLETED:
      return {
        ...state,
        fetchingAllModuleAbilityTheme: false,
        allModuleAbilityTheme: action.allModuleAbilityTheme
      };
    case types.GET_ALL_MODULE_ABILITY_THEME_ERROR:
      return {
        ...state,
        fetchingAllModuleAbilityTheme: false,
        fetchingAllModuleAbilityThemeError:
          action.fetchingAllModuleAbilityThemeError
      };

    case types.GET_ALL_MODULE_LESSON_REQUEST:
      return {
        ...state,
        fetchingAllModuleLesson: true
      };
    case types.GET_ALL_MODULE_LESSON_COMPLETED:
      return {
        ...state,
        fetchingAllModuleLesson: false,
        allModuleLesson: action.allModuleLesson
      };
    case types.GET_ALL_MODULE_LESSON_ERROR:
      return {
        ...state,
        fetchingAllModuleLesson: false,
        fetchingAllModuleLessonError: action.fetchingAllModuleLessonError
      };

    case types.GET_ALL_MODULE_LESSON_THEME_REQUEST:
      return {
        ...state,
        fetchingAllModuleLessonTheme: true
      };
    case types.GET_ALL_MODULE_LESSON_THEME_COMPLETED:
      return {
        ...state,
        fetchingAllModuleLessonTheme: false,
        allModuleLessonTheme: action.allModuleLessonTheme
      };
    case types.GET_ALL_MODULE_LESSON_THEME_ERROR:
      return {
        ...state,
        fetchingAllModuleLessonTheme: false,
        fetchingAllModuleLessonThemeError:
          action.fetchingAllModuleLessonThemeError
      };

    case types.ADD_MODULE_LESSON_REQUEST:
      return {
        ...state,
        fetchingAddModuleLesson: true
      };
    case types.ADD_MODULE_LESSON_COMPLETED:
      return {
        ...state,
        fetchingAddModuleLesson: false,
        moduleLesson: action.moduleLesson
      };
    case types.ADD_MODULE_LESSON_ERROR:
      return {
        ...state,
        fetchingAddModuleLesson: false,
        fetchingAddModuleLessonError: action.fetchingAddModuleLessonError
      };

    case types.UPDATE_MODULE_LESSON_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleLesson: true
      };
    case types.UPDATE_MODULE_LESSON_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleLesson: false,
        updateModuleLesson: action.updateModuleLesson
      };
    case types.UPDATE_MODULE_LESSON_ERROR:
      return {
        ...state,
        fetchingUpdateModuleLesson: false,
        fetchingUpdateModuleLessonError: action.fetchingUpdateModuleLessonError
      };

    case types.DELETE_MODULE_LESSON_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleLesson: true
      };
    case types.DELETE_MODULE_LESSON_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleLesson: false,
        deleteModuleLesson: action.deleteModuleLesson
      };
    case types.DELETE_MODULE_LESSON_ERROR:
      return {
        ...state,
        fetchingDeleteModuleLesson: false,
        fetchingDeleteModuleLessonError: action.fetchingDeleteModuleLessonError
      };

    case types.GET_ALL_LESSON_TYPE_REQUEST:
      return {
        ...state,
        fetchingAllLessonType: true
      };
    case types.GET_ALL_LESSON_TYPE_COMPLETED:
      return {
        ...state,
        fetchingAllLessonType: false,
        allLessonType: action.allLessonType
      };
    case types.GET_ALL_LESSON_TYPE_ERROR:
      return {
        ...state,
        fetchingAllLessonType: false,
        fetchingAllLessonTypeError: action.fetchingAllLessonTypeError
      };

    case types.GET_ALL_RESOURCE_LIST_REQUEST:
      return {
        ...state,
        fetchingAllResourceList: true
      };
    case types.GET_ALL_RESOURCE_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllResourceList: false,
        allResourceList: action.allResourceList
      };
    case types.GET_ALL_RESOURCE_LIST_ERROR:
      return {
        ...state,
        fetchingAllResourceList: false,
        fetchingAllResourceListError: action.fetchingAllResourceListError
      };

    case types.GET_LESSON_RESOURCE_LIST_REQUEST:
      return {
        ...state,
        fetchingLessonResourceList: true
      };
    case types.GET_LESSON_RESOURCE_LIST_COMPLETED:
      return {
        ...state,
        fetchingLessonResourceList: false,
        lessonResourceList: action.lessonResourceList
      };
    case types.GET_LESSON_RESOURCE_LIST_ERROR:
      return {
        ...state,
        fetchingLessonResourceList: false,
        fetchingLessonResourceListError: action.fetchingLessonResourceListError
      };

    case types.GET_ALL_ROOM_TYPES_LIST_REQUEST:
      return {
        ...state,
        fetchingAllRoomTypesList: true
      };
    case types.GET_ALL_ROOM_TYPES_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllRoomTypesList: false,
        allRoomTypesList: action.allRoomTypesList
      };
    case types.GET_ALL_ROOM_TYPES_LIST_ERROR:
      return {
        ...state,
        fetchingAllRoomTypesList: false,
        fetchingAllRoomTypesListError: action.fetchingAllRoomTypesListError
      };

    case types.GET_ALL_MODULE_ROOM_LIST_REQUEST:
      return {
        ...state,
        fetchingAllModuleRoomList: true
      };
    case types.GET_ALL_MODULE_ROOM_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllModuleRoomList: false,
        allModuleRoomList: action.allModuleRoomList
      };
    case types.GET_ALL_MODULE_ROOM_LIST_ERROR:
      return {
        ...state,
        fetchingAllModuleRoomList: false,
        fetchingAllModuleRoomListError: action.fetchingAllModuleRoomListError
      };

    case types.ADD_MODULE_ROOM_LIST_REQUEST:
      return {
        ...state,
        fetchingModuleRoomList: true
      };
    case types.ADD_MODULE_ROOM_LIST_COMPLETED:
      return {
        ...state,
        fetchingModuleRoomList: false,
        moduleRoomList: action.moduleRoomList
      };
    case types.ADD_MODULE_ROOM_LIST_ERROR:
      return {
        ...state,
        fetchingModuleRoomList: false,
        fetchingModuleRoomListError: action.fetchingModuleRoomListError
      };

    case types.UPDATE_MODULE_ROOM_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleRoom: true
      };
    case types.UPDATE_MODULE_ROOM_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleRoom: false,
        updatedModuleRoom: action.updatedModuleRoom
      };
    case types.UPDATE_MODULE_ROOM_ERROR:
      return {
        ...state,
        fetchingUpdateModuleRoom: false,
        fetchingUpdateModuleRoomError: action.fetchingUpdateModuleRoomError
      };

    case types.DELETE_MODULE_ROOM_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleRoom: true
      };
    case types.DELETE_MODULE_ROOM_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleRoom: false,
        deletedModuleRoom: action.deletedModuleRoom
      };
    case types.DELETE_MODULE_ROOM_ERROR:
      return {
        ...state,
        fetchingDeleteModuleRoom: false,
        fetchingDeleteModuleRoomError: action.fetchingDeleteModuleRoomError
      };

    case types.GET_ALL_MODULE_RESOURCE_LIST_REQUEST:
      return {
        ...state,
        fetchingAllModuleResourceList: true
      };
    case types.GET_ALL_MODULE_RESOURCE_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllModuleResourceList: false,
        allModuleResourceList: action.allModuleResourceList
      };
    case types.GET_ALL_MODULE_RESOURCE_LIST_ERROR:
      return {
        ...state,
        fetchingAllModuleResourceList: false,
        fetchingAllModuleResourceListError:
          action.fetchingAllModuleResourceListError
      };

    case types.ADD_MODULE_RESOURCE_REQUEST:
      return {
        ...state,
        fetchingAddModuleResource: true
      };
    case types.ADD_MODULE_RESOURCE_COMPLETED:
      return {
        ...state,
        fetchingAddModuleResource: false,
        moduleResource: action.moduleResource
      };
    case types.ADD_MODULE_RESOURCE_ERROR:
      return {
        ...state,
        fetchingAddModuleResource: false,
        fetchingAddModuleResourceError: action.fetchingAddModuleResourceError
      };

    case types.UPDATE_MODULE_RESOURCE_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleResource: true
      };
    case types.UPDATE_MODULE_RESOURCE_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleResource: false,
        updatedModuleResource: action.updatedModuleResource
      };
    case types.UPDATE_MODULE_RESOURCE_ERROR:
      return {
        ...state,
        fetchingUpdateModuleResource: false,
        fetchingUpdateModuleResourceError:
          action.fetchingUpdateModuleResourceError
      };

    case types.DELETE_MODULE_RESOURCE_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleResource: true
      };
    case types.DELETE_MODULE_RESOURCE_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleResource: false,
        deletedModuleResource: action.deletedModuleResource
      };
    case types.DELETE_MODULE_RESOURCE_ERROR:
      return {
        ...state,
        fetchingDeleteModuleResource: false,
        fetchingDeleteModuleRoomError: action.fetchingDeleteModuleResourceError
      };

    case types.GET_ALL_RESOURCE_TYPE_LIST_REQUEST:
      return {
        ...state,
        fetchingAllResourceTypeList: true
      };
    case types.GET_ALL_RESOURCE_TYPE_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllResourceTypeList: false,
        allResourceTypeList: action.allResourceTypeList
      };
    case types.GET_ALL_RESOURCE_TYPE_LIST_ERROR:
      return {
        ...state,
        fetchingAllResourceTypeList: false,
        fetchingAllResourceTypeListError:
          action.fetchingAllResourceTypeListError
      };

    case types.GET_ALL_MODULE_REFERENCE_LIST_REQUEST:
      return {
        ...state,
        fetchingAllModuleReferenceList: true
      };
    case types.GET_ALL_MODULE_REFERENCE_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllModuleReferenceList: false,
        allModuleReferenceList: action.allModuleReferenceList
      };
    case types.GET_ALL_MODULE_REFERENCE_LIST_ERROR:
      return {
        ...state,
        fetchingAllModuleReferenceList: false,
        fetchingAllModuleReferenceListError:
          action.fetchingAllModuleReferenceListError
      };

    case types.ADD_MODULE_REFERENCE_REQUEST:
      return {
        ...state,
        fetchingAddModuleReference: true
      };
    case types.ADD_MODULE_REFERENCE_COMPLETED:
      return {
        ...state,
        fetchingAddModuleReference: false,
        moduleReference: action.moduleReference
      };
    case types.ADD_MODULE_REFERENCE_ERROR:
      return {
        ...state,
        fetchingAddModuleReference: false,
        fetchingAddModuleReferenceError: action.fetchingAddModuleReferenceError
      };

    case types.UPDATE_MODULE_REFERENCE_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleReference: true
      };
    case types.UPDATE_MODULE_REFERENCE_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleReference: false,
        updatedModuleReference: action.updatedModuleReference
      };
    case types.UPDATE_MODULE_REFERENCE_ERROR:
      return {
        ...state,
        fetchingUpdateModuleReference: false,
        fetchingUpdateModuleReferenceError:
          action.fetchingUpdateModuleReferenceError
      };

    case types.DELETE_MODULE_REFERENCE_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleReference: true
      };
    case types.DELETE_MODULE_REFERENCE_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleReference: false,
        deletedModuleReference: action.deletedModuleReference
      };
    case types.DELETE_MODULE_REFERENCE_ERROR:
      return {
        ...state,
        fetchingDeleteModuleReference: false,
        fetchingDeleteModuleReferenceError:
          action.fetchingDeleteModuleReferenceError
      };

    case types.GET_ALL_MODULE_SITE_LIST_REQUEST:
      return {
        ...state,
        fetchingAllModuleSiteList: true
      };
    case types.GET_ALL_MODULE_SITE_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllModuleSiteList: false,
        allModuleSiteList: action.allModuleSiteList
      };
    case types.GET_ALL_MODULE_SITE_LIST_ERROR:
      return {
        ...state,
        fetchingAllModuleSiteList: false,
        fetchingAllModuleSiteListError: action.fetchingAllModuleSiteListError
      };

    case types.ADD_MODULE_SITE_REQUEST:
      return {
        ...state,
        fetchingAddModuleSite: true
      };
    case types.ADD_MODULE_SITE_COMPLETED:
      return {
        ...state,
        fetchingAddModuleSite: false,
        moduleSite: action.moduleSite
      };
    case types.ADD_MODULE_SITE_ERROR:
      return {
        ...state,
        fetchingAddModuleSite: false,
        fetchingAddModuleSiteError: action.fetchingAddModuleSiteError
      };

    case types.UPDATE_MODULE_SITE_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleSite: true
      };
    case types.UPDATE_MODULE_SITE_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleSite: false,
        updatedModuleSite: action.updatedModuleSite
      };
    case types.UPDATE_MODULE_SITE_ERROR:
      return {
        ...state,
        fetchingUpdateModuleSite: false,
        fetchingUpdateModuleSiteError: action.fetchingUpdateModuleSiteError
      };

    case types.DELETE_MODULE_SITE_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleSite: true
      };
    case types.DELETE_MODULE_SITE_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleSite: false,
        deletedModuleSite: action.deletedModuleSite
      };
    case types.DELETE_MODULE_SITE_ERROR:
      return {
        ...state,
        fetchingDeleteModuleSite: false,
        fetchingDeleteModuleSiteError: action.fetchingDeleteModuleSiteError
      };

    case types.GET_MODULE_SCHEDULE_REQUEST:
      return {
        ...state,
        fetchingModuleSchedule: true
      };
    case types.GET_MODULE_SCHEDULE_COMPLETED:
      return {
        ...state,
        fetchingModuleSchedule: false,
        moduleSchedule: action.moduleSchedule
      };
    case types.GET_MODULE_SCHEDULE_ERROR:
      return {
        ...state,
        fetchingModuleSchedule: false,
        fetchingModuleScheduleError: action.fetchingModuleScheduleError
      };

    case types.GET_MODULE_ESTIMATE_REQUEST:
      return {
        ...state,
        fetchingModuleEstimate: true
      };
    case types.GET_MODULE_ESTIMATE_COMPLETED:
      return {
        ...state,
        fetchingModuleEstimate: false,
        moduleEstimate: action.moduleEstimate
      };
    case types.GET_MODULE_ESTIMATE_ERROR:
      return {
        ...state,
        fetchingModuleEstimate: false,
        fetchingModuleEstimateError: action.fetchingModuleEstimateError
      };

    case types.GET_ALL_MODULE_CRITERION_LIST_REQUEST:
      return {
        ...state,
        fetchingAllModuleCriterionList: true
      };
    case types.GET_ALL_MODULE_CRITERION_LIST_COMPLETED:
      return {
        ...state,
        fetchingAllModuleCriterionList: false,
        allModuleCriterionList: action.allModuleCriterionList
      };
    case types.GET_ALL_MODULE_CRITERION_LIST_ERROR:
      return {
        ...state,
        fetchingAllModuleCriterionList: false,
        fetchingAllModuleCriterionListError:
          action.fetchingAllModuleCriterionListError
      };

    case types.ADD_MODULE_CRITERION_REQUEST:
      return {
        ...state,
        fetchingAddModuleCriterion: true
      };
    case types.ADD_MODULE_CRITERION_COMPLETED:
      return {
        ...state,
        fetchingAddModuleCriterion: false,
        moduleCriterion: action.moduleCriterion
      };
    case types.ADD_MODULE_CRITERION_ERROR:
      return {
        ...state,
        fetchingAddModuleCriterion: false,
        fetchingAddModuleCriterionError: action.fetchingAddModuleCriterionError
      };

    case types.UPDATE_MODULE_CRITERION_REQUEST:
      return {
        ...state,
        fetchingUpdateModuleCriterion: true
      };
    case types.UPDATE_MODULE_CRITERION_COMPLETED:
      return {
        ...state,
        fetchingUpdateModuleCriterion: false,
        updatedModuleCriterion: action.updatedModuleCriterion
      };
    case types.UPDATE_MODULE_CRITERION_ERROR:
      return {
        ...state,
        fetchingUpdateModuleCriterion: false,
        fetchingUpdateModuleCriterionError:
          action.fetchingUpdateModuleCriterionError
      };

    case types.DELETE_MODULE_CRITERION_REQUEST:
      return {
        ...state,
        fetchingDeleteModuleCriterion: true
      };
    case types.DELETE_MODULE_CRITERION_COMPLETED:
      return {
        ...state,
        fetchingDeleteModuleCriterion: false,
        deletedModuleCriterion: action.deletedModuleCriterion
      };
    case types.DELETE_MODULE_CRITERION_ERROR:
      return {
        ...state,
        fetchingDeleteModuleCriterion: false,
        fetchingDeleteModuleCriterionError:
          action.fetchingDeleteModuleCriterionError
      };

    case types.GET_ALL_MODULE_COMPILERS_REQUEST:
      return {
        ...state,
        fetchingAllModuleCompilers: true
      };
    case types.GET_ALL_MODULE_COMPILERS_COMPLETED:
      return {
        ...state,
        fetchingAllModuleCompilers: false,
        allModuleCompilers: action.allModuleCompilers
      };
    case types.GET_ALL_MODULE_COMPILERS_ERROR:
      return {
        ...state,
        fetchingAllModuleCompilers: false,
        fetchingAllModuleCompilersError: action.fetchingAllModuleCompilersError
      };

    case types.MODULE_COMPILERS_REQUEST:
      return {
        ...state,
        fetchingModuleCompilers: true
      };
    case types.MODULE_COMPILERS_COMPLETED:
      return {
        ...state,
        fetchingModuleCompilers: false,
        moduleCompilers: action.moduleCompilers
      };
    case types.MODULE_COMPILERS_ERROR:
      return {
        ...state,
        fetchingModuleCompilers: false,
        fetchingModuleCompilersError: action.fetchingModuleCompilersError
      };

    case types.GET_ORGANIZATION_STAFF_REQUEST:
      return {
        ...state,
        fetchingOrganizationStaff: true
      };
    case types.GET_ORGANIZATION_STAFF_COMPLETED:
      return {
        ...state,
        fetchingOrganizationStaff: false,
        organizationStaff: action.organizationStaff
      };
    case types.GET_ORGANIZATION_STAFF_ERROR:
      return {
        ...state,
        fetchingOrganizationStaff: false,
        fetchingOrganizationStaffError: action.fetchingOrganizationStaffError
      };

    default:
      return state;
  }
};
